export default {
  nav: {
    brandProducts: 'Produtos Positive', discover: 'Descobrir', allProducts: 'Todos os produtos',
    otherProducts: 'Outros produtos: {count}',
    connectedApps: 'Apps conectadas', currentProduct: 'Está em {product}',
    openApp: 'Abrir {product} num novo separador', discoverProduct: 'Descobrir {product}',
  },
  actions: {
    tryFree: 'Experimentar grátis', discover: 'Descobrir', discoverProduct: 'Descobrir {product}',
    backToCatalog: 'Voltar a todos os produtos',
    signIn: 'Iniciar sessão', close: 'Fechar',
  },
  agent: {
    useAssistant: 'Usar no seu assistente de IA', title: 'Use {product} no seu assistente de IA',
    description: 'Ligue o seu assistente a {product} através do servidor MCP.',
    other: 'Outro',
    copyPrompt: 'Copiar prompt',
    copyDone: 'Copiado', copyRetry: 'Tentar',
    connectTitle: 'Escolha o seu assistente', connect: 'Ligar', availableFor: 'Disponível para {product}',
    connectionHint: 'Poderá ter de iniciar sessão e autorizar o acesso.',
    permissions: 'O seu assistente acede apenas aos dados e ações que autorizar.',
    copy: 'Copiar o prompt para ligar o seu agente a {product}',
    copied: 'Prompt copiado. Cole-o no seu agente.', copyError: 'Não foi possível copiar o prompt. Tente novamente.',
  },
  catalog: {
    title: 'Descubra os produtos Positive', description: 'Ferramentas que complementam {product}.',
    descriptionDefault: 'Ferramentas para as suas equipas de marketing e vendas.', empty: 'Não há produtos para descobrir.',
  },
  product: { featuresTitle: 'O que pode fazer com {product}' },
  status: { current: 'App atual', connected: 'App conectada' },
  accessibility: { openMenu: 'Abrir a navegação de produtos', newTab: 'Abre num novo separador' },
  categories: { emailSignatures: 'Assinaturas de email', emailing: 'Email marketing', seo: 'SEO & GEO', socialMedia: 'Redes sociais', sales: 'Vendas' },
  products: {
    signitic: {
      tagline: 'Gestão de assinaturas de email',
      description: 'Centralize todas as assinaturas de email e transforme-as num canal de marketing.',
      features: ['Assinaturas uniformes em toda a empresa', 'Campanhas de banners em cada email', 'Análise de cliques e alcance'],
    },
    user: {
      tagline: 'Email marketing e envolvimento dos clientes',
      description: 'Automação, CRM e chat em direto para envolver os seus contactos no momento certo.',
      features: ['Percursos automatizados de email e SMS', 'CRM com contactos e oportunidades', 'Chat em direto no seu site'],
    },
    surfer: {
      tagline: 'Otimização de conteúdos SEO e GEO',
      description: 'Escreva conteúdos bem posicionados no Google e citados pelos assistentes de IA.',
      features: ['Briefs de conteúdo para melhorar o posicionamento no Google', 'Citações no ChatGPT e nas respostas de IA', 'Redação de artigos com IA'],
    },
    iconosquare: {
      tagline: 'Gestão e análise de redes sociais',
      description: 'Agende, responda e meça o desempenho de todas as redes sociais numa única plataforma.',
      features: ['Agendamento de publicações em cada rede', 'Uma caixa de entrada para comentários e mensagens privadas', 'Análises e relatórios'],
    },
    humanlinker: {
      tagline: 'Copiloto de vendas com IA',
      description: 'Aborde cada potencial cliente de forma personalizada e transforme conversas em vendas.',
      features: ['Recomendações de potenciais clientes com IA', 'Sequências de contacto personalizadas', 'Preparação de reuniões num clique'],
    },
    ubic: {
      tagline: 'Chamadas em paralelo para equipas de vendas',
      description: 'Uma ferramenta de chamadas em paralelo que permite às equipas de vendas contactar mais potenciais clientes em menos tempo.',
      features: ['Ligue a vários potenciais clientes em simultâneo', 'Só as chamadas atendidas lhe são transferidas', 'Sincronização com o seu CRM'],
    },
    nocrm: {
      tagline: 'Gestão de leads para comerciais',
      description: 'Acompanhe cada lead do primeiro contacto até à venda, sem a complexidade de um CRM.',
      features: ['Todos os leads num único pipeline', 'Lembretes para não perder oportunidades', 'Aplicação móvel para o trabalho no terreno'],
    },
  },
};
